import React from 'react';
import { Helmet } from 'react-helmet-async';
import { Link } from 'react-router-dom';
import './Solutions.css';

const SECTORS = [
  {
    emoji: "🍽️",
    sector: "Restaurants & Traiteurs",
    problem: "Vos clients ne trouvent pas votre menu en ligne et appellent pour les horaires.",
    solution: "Site vitrine avec menu en ligne, formulaire de reservation, horaires et Google Maps integres.",
    services: ["Site web", "Landing page"],
    slug: "developpement-web",
  },
  {
    emoji: "👗",
    sector: "Boutiques & Mode",
    problem: "Vous vendez uniquement sur WhatsApp — lent, peu professionnel, pas de suivi.",
    solution: "Boutique e-commerce avec paiement Orange Money et Wave, gestion des stocks, livraisons.",
    services: ["E-commerce", "Orange Money"],
    slug: "applications-e-commerce",
  },
  {
    emoji: "🚗",
    sector: "Transport & Livraison",
    problem: "Pas d'outil pour gerer les reservations et les chauffeurs en temps reel.",
    solution: "Application mobile de reservation avec geolocalisation, notifications push et interface admin.",
    services: ["App mobile", "Geolocalisation"],
    slug: "applications-mobiles",
  },
  {
    emoji: "🏥",
    sector: "Cliniques & Sante",
    problem: "Les rendez-vous se prennent par appel — file d'attente, oublis, agenda desorganise.",
    solution: "Systeme de prise de rendez-vous en ligne, rappels SMS/email, dossiers patients numeriques.",
    services: ["App web", "App mobile"],
    slug: "applications-mobiles",
  },
  {
    emoji: "🏗️",
    sector: "BTP & Artisans",
    problem: "Pas de vitrine professionnelle pour montrer vos realisations et obtenir des devis.",
    solution: "Site portfolio avec galerie de projets, formulaire de devis en ligne et avis clients.",
    services: ["Site web", "Portfolio"],
    slug: "developpement-web",
  },
  {
    emoji: "📚",
    sector: "Formations & Ecoles",
    problem: "Inscriptions manuelles, paiements en cash, pas de suivi des apprenants.",
    solution: "Plateforme e-learning avec inscription, paiement mobile, suivi de progression et certificats.",
    services: ["App web", "E-learning"],
    slug: "applications-e-commerce",
  },
];

export default function Solutions() {
  return (
    <>
      <Helmet>
        <title>Solutions par secteur — NEXUS SOLUTIONS</title>
        <meta name="description" content="Decouvrez comment NEXUS SOLUTIONS aide les restaurants, boutiques, cliniques, transporteurs et autres PME ivoiriennes a se digitaliser." />
      </Helmet>

      <div className="solutions-hero">
        <div className="solutions-hero__label">Solutions metier</div>
        <h1 className="solutions-hero__title">
          Une solution<br />
          <span>pour chaque secteur</span>
        </h1>
        <p className="solutions-hero__sub">
          On ne vend pas des templates. On resout des problemes concrets pour les entrepreneurs ivoiriens.
        </p>
      </div>

      <section className="solutions-grid-section">
        <div className="solutions-grid-inner">
          <div className="solutions-grid">
            {SECTORS.map(s => (
              <div className="solutions-card" key={s.sector}>
                <div className="solutions-card__emoji">{s.emoji}</div>
                <h2 className="solutions-card__sector">{s.sector}</h2>
                <div className="solutions-card__problem">
                  <span className="solutions-card__problem-label">Probleme courant</span>
                  <p>{s.problem}</p>
                </div>
                <div className="solutions-card__solution">
                  <span className="solutions-card__solution-label">Notre solution</span>
                  <p>{s.solution}</p>
                </div>
                <div className="solutions-card__tags">
                  {s.services.map(tag => (
                    <span className="solutions-card__tag" key={tag}>{tag}</span>
                  ))}
                </div>
                <Link to={`/services/${s.slug}`} className="solutions-card__link">
                  Voir le service →
                </Link>
              </div>
            ))}
          </div>
        </div>
      </section>

      <section className="solutions-cta">
        <div className="solutions-cta__inner">
          <h2 className="solutions-cta__title">Votre secteur n'est pas dans la liste ?</h2>
          <p className="solutions-cta__text">
            On a travaille avec des profils varies. Decrivez votre activite et on vous propose une solution adaptee.
          </p>
          <div className="solutions-cta__actions">
            <Link to="/devis" className="solutions-cta__btn">Demander un devis gratuit</Link>
            <a
              href="mailto:contact@nxs-solutions.com"
              className="solutions-cta__btn solutions-cta__btn--wa"
            >
              Nous ecrire par email
            </a>
          </div>
        </div>
      </section>
    </>
  );
}
